import Error from '../model/Error';
import ResponseParser from '../parser/ResponseParser';
import axios from 'axios';

export default class ClubStatsRepository {
    static getDepartmentMemberAllocation(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/stats/department-member-allocation`)
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static putDepartmentMemberAllocationJob(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/clubs/${clubId}/stats/department-member-allocation/jobs`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static getDepartmentMemberAllocationJob(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/stats/department-member-allocation/jobs`)
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static getMembershipCountOverTimeStats(clubId, departmentId, teamId) {
        const params = {
            departmentId,
            teamId,
        };
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/stats/membership-count-over-time`, { params })
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static putMembershipCountOverTimeStatsJob(clubId, departmentId, teamId) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/clubs/${clubId}/stats/membership-count-over-time/jobs`, { departmentId, teamId })
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static getMembershipCountOverTimeStatsJob(clubId, departmentId, teamId) {
        const params = {
            departmentId,
            teamId,
        };
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/stats/membership-count-over-time/jobs`, { params })
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static getMembershipDemographics(clubId, departmentId, teamId) {
        const params = {
            departmentId,
            teamId,
        };
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/stats/member-demographics`, { params })
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static putMembershipDemographicsJob(clubId, departmentId, teamId) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/clubs/${clubId}/stats/member-demographics/jobs`, { departmentId, teamId })
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static getMembershipDemographicsJob(clubId, departmentId, teamId) {
        const params = {
            departmentId,
            teamId,
        };
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/stats/member-demographics/jobs`, { params })
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static getMembershipDemographicsForAll(clubId, date, mode = 'default') {
        const params = {
            date,
            mode,
        };
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/stats/member-demographics-for-all`, { params })
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static putMembershipDemographicsForAllJob(clubId, date, mode = 'default') {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/clubs/${clubId}/stats/member-demographics-for-all/jobs`, { date, mode })
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static getMembershipDemographicsForAllJob(clubId, date, mode = 'default') {
        const params = {
            date,
            mode,
        };
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/stats/member-demographics-for-all/jobs`, { params })
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static getMembershipDemographicsForAllXlsx(clubId, date, mode = 'default') {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/stats/member-demographics-for-all/xlsx?date=${date}&mode=${mode}`, { responseType: 'blob' })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;

                    const filename = new ResponseParser().getFilenameFromHeaders(response.headers);

                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    resolve();
                })
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static getMemberLoginData(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/stats/member-login-data`)
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
